<template>
    <div class="container">
      <h2 class="text-white">{{title?title:'Notification'}}</h2>
      <h4 class="text-white">{{subtitle}}</h4>
      <p v-html="description"></p> 
    </div>
  </template>
<script>
  export default {
    name: "vue-toastr",
    props: {
        title: {
            type: String,
            description: 'Notification'
        },
        subtitle: {
            type: String, 
            description: 'Sub Title'
        },
        description: null
    },
  }
</script>